import "moment/locale/id";

export const convertAreaList = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    let total = 0;
    item.cities.forEach((i) => (
      total += i.subdistricts.length
    ))
    converted.push({
      key: index + 1,
      id: item.id,
      area: item.name,
      total_kota: item.cities.length,
      total_kecamatan: total
    });
  });
  return converted;
};


